module.exports = __webpack_public_path__ + "static/img/jtjs.93c18c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jtjs.jpg
// module id = yoGx
// module chunks = 1